module.exports = __webpack_public_path__ + "img/04-3-1功能确认.96c4f01b.svg";